export const DEFAULT_SELECTIONS = {
    FOREX: {
        instrument: 'EUR_USD',
        timeframe: 'M15'
    },
    STOCKS: {
        instrument: 'GOOGL',
        timeframe: 'M15'
    },
    INDICES: {
        instrument: 'I:SPXTIV',
        timeframe: 'M15'
    },
    CRYPTO: {
        instrument: 'X:BTCUSD',
        timeframe: 'M15'
    }
};

export const TOOLS = {
    NONE: 'none',
    HLINE: 'horizontal_line'
};

export const LINE_TYPES = {
    SUPPORT: 'support',
    RESISTANCE: 'resistance',
    CUSTOM: 'custom'
};

export const LINE_STYLES = {
    [LINE_TYPES.SUPPORT]: {
        color: 'rgba(38, 166, 154, 0.6)',  // #26a69a with 60% opacity
        lineWidth: 2,
        lineStyle: 0, // Solid
        title: 'Support',
        titleBackgroundColor: 'rgba(38, 166, 154, 0.1)',
        titleColor: 'rgba(38, 166, 154, 1)'
    },
    [LINE_TYPES.RESISTANCE]: {
        color: 'rgba(239, 83, 80, 0.6)',  // #ef5350 with 60% opacity
        lineWidth: 2,
        lineStyle: 0, // Solid
        title: 'Resistance',
        titleBackgroundColor: 'rgba(239, 83, 80, 0.1)',
        titleColor: 'rgba(239, 83, 80, 1)'
    },
    [LINE_TYPES.CUSTOM]: {
        color: 'rgba(33, 150, 243, 0.6)',  // #2196F3 with 60% opacity
        lineWidth: 1,
        lineStyle: 0, // Solid
        title: 'Custom',
        titleBackgroundColor: 'rgba(33, 150, 243, 0.1)',
        titleColor: 'rgba(33, 150, 243, 1)'
    }
};

export const HOVER_TRANSITION = 'all 0.2s ease-in-out'; 